import { InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';

export const DBrowserCreceMasiOS: InAppBrowserOptions = {
    location: 'no'
    , zoom: 'no'
    , hidenavigationbuttons: 'yes'
    , toolbar: 'no'
    , transitionstyle: 'crossdissolve'
    , hidespinner: 'yes'
    , beforeload: 'yes'
}


export const DBrowserCreceMasAndroid: InAppBrowserOptions = {
    location: 'no'
    , zoom: 'no'
    , hidenavigationbuttons: 'yes'
    , fullscreen: 'no'
    , beforeload: 'yes'
}


export const DBrowserPremiadosiOS: InAppBrowserOptions = {
    location: 'no'
    , zoom: 'yes'
    , hidenavigationbuttons: 'yes'
    , toolbar: 'no'
    , transitionstyle: 'crossdissolve'
    , hidespinner: 'yes'
    , beforeload: 'yes'
}

export const DBrowserPremiadosAndroid: InAppBrowserOptions = {
    location: 'no'
    , zoom: 'yes'
    , hidenavigationbuttons: 'yes'
    , fullscreen: 'no'
    , beforeload: 'yes'
}

export const DBrowserEnkoiOS: InAppBrowserOptions = {
    location: 'no'
    , zoom: 'no'
    , hidenavigationbuttons: 'yes'
    , toolbar: 'no'
    , transitionstyle: 'crossdissolve'
    , hidespinner: 'yes'
    , beforeload: 'yes'
    , clearcache: 'yes'
    , clearsessioncache: 'yes'
    , allowInlineMediaPlayback: 'yes'
    , usewkwebview: 'yes'
}

export const DBrowserEnkoAndroid: InAppBrowserOptions = {
    location: 'no'
    , zoom: 'no'
    , hidenavigationbuttons: 'yes'
    , fullscreen: 'no'
    , beforeload: 'yes'
    , clearcache: 'yes'
    , clearsessioncache: 'yes'
}

export const DBrowserConsumeriOS: InAppBrowserOptions = {
    location: 'no',
    zoom: 'no',
    hidenavigationbuttons: 'yes',
    fullscreen: 'no',
    toolbar: 'yes',
    closebuttoncaption: '‹  Regresar',
    closebuttoncolor: '#004a97',
    toolbarcolor: '#ffffff',
    toolbarposition: 'top'
}

export const DBrowserEnfriadoresiOS: InAppBrowserOptions = {
    location: 'no',
    zoom: 'no',
    hidenavigationbuttons: 'yes',
    toolbar: 'yes',
    transitionstyle: 'crossdissolve',
    hidespinner: 'yes',
    closebuttoncaption: '‹',
    closebuttoncolor: '#ffffff',
    toolbarcolor: '#00264d',
    toolbarposition: 'top',
    toolbartranslucent: 'no',
    presentationstyle: 'fullscreen',
    usewkwebview: 'yes'
}

export const DBrowserEnfriadoresAndroid: OpenOptions = {
    url: '',
    toolbarColor: '#004a97',
}

interface OpenOptions {
    url?: string;
    toolbarColor?: string;
}
